import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import { useForm, FormProvider } from "react-hook-form";
import { useAddImageMutation } from "services/image/imageApi";
import ImagesEditor from "./ImagesEditor";
import { UpsertImageRequest } from "services/image/typing";
import CircularProgress from "@mui/material/CircularProgress";

const ImageUploader = () => {
  const methods = useForm();

  const [uploadImage, { data, isLoading }] = useAddImageMutation();
  // const { data: project, error, projectIsLoading} =

  const onSubmit = async (data: any) => {
    
    const promises: Array<Promise<any>> = data.images.map((image: UpsertImageRequest) => {
      // Make sure the obfuscations and 
      image = {
        ...image,
        obfuscationStr: (image.obfuscationStr && image.obfuscationStr) !== "[]" ? image.obfuscationStr : null,
        styles: (image.styles && image.styles) !== "{}" ? image.styles : null,
        variant: !image.variant ? null : image.variant,
        unifiedId: !image.unifiedId ? null : image.unifiedId,
        variantNotes: (image.variantNotes && image.variantNotes !== '') ? image.variantNotes : null,
      }
      console.log(image);
      return uploadImage(image).unwrap();
    });

    let results = await Promise.all(promises);

    // if (results.length) {
    //   methods.reset();
    //   return
    // }

  };

  return (
    <Box m={2}>
      <Stack sx={{ alignItems: "center", justifyContent: "center" }}>
        <FormProvider {...methods}>
          <form 
            style={{ width: "100%"}}
            onSubmit={methods.handleSubmit(onSubmit)}>
            <ImagesEditor name="images" allowUploads />
            <Button
              variant="contained"
              startIcon={<CloudUploadIcon />}
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                "Submit"
              )}
            </Button>
            <Box>
              { isLoading
                ? "Please hold tight while the server processes your images. It is scaling and converting them to the various formats."
                : null
              }
            </Box>
            { <Box color="error"> { methods.formState.isValid ? null : "One or more fields have errors"}</Box> }
          </form>
        </FormProvider>
      </Stack>
    </Box>
  );
};

export default ImageUploader;
